import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const ListByArticle = () => import(/* webpackChunkName: "stocks" */ '@/views/Stocks/ListByArticle.vue');
const ListByDistributor = () => import(/* webpackChunkName: "stocks" */ '@/views/Stocks/ListByDistributor.vue');

let deliveryNotesPages = {
  path: '/stocks',
  redirect: '/stocks',
  component: DashboardLayout,
  name: 'Stocks',
  meta: {
    title: 'Stocks',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'StockByArticle',
      meta: {
        title: 'Stock General',
        auth: ['stocks.articles'],
      },
      component: ListByArticle,
    },
    {
      path: 'distributor',
      name: 'StockByDistributor',
      meta: {
        title: 'Stock por distribuidor',
        auth: ['stocks.distributors'],
      },
      component: ListByDistributor,
    },
  ],
};

export default deliveryNotesPages;
